import { EventEmitter, Injectable } from '@angular/core';
import * as echarts from 'echarts';

@Injectable({
  providedIn: 'root'
})
export class EchartService {
  readonly exportEvent = new EventEmitter<any>();
  readonly selectEvent = new EventEmitter<any>();

  genericConfig = {
    tooltip: { trigger: 'axis' },
    toolbox: { feature: { saveAsImage: {} } },
    xAxis: { type: 'category', data: [] },
    yAxis: { type: 'value' },
    series: []
  };

  emitExport(data: any) {
    this.exportEvent.emit(data);
  }

  emitSelect(data: any) {
    this.selectEvent.emit(data);
  }

  renderChart(chartDiv: HTMLElement, options: any) {
    const chartInstance = echarts.init(chartDiv);
    chartInstance.setOption({ ...this.genericConfig, ...options });
    return chartInstance;
  }

  updateChart(chartInstance: any, options: any) {
    chartInstance.setOption(options, true);
  }
}
